var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28 17v2c0 2.2 1.8 4 4 4s4-1.8 4-4v-2c0-2.2-1.8-4-4-4s-4 1.8-4 4zm6 0v2c0 1.1-.9 2-2 2s-2-.9-2-2v-2c0-1.1.9-2 2-2s2 .9 2 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#df2c30",
    d: "m62 61h-2c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m56 61h-14.2c.5-.8.7-1.8.5-2.7l-3.3-20.3 1.9-9.7 3.6-9.1c.3-.7.4-1.4.4-2.1v-7.1c0-1.7-1.3-3-3-3s-3 1.3-3 3v5.8l-3.6 9.2h-6.6l-3.7-9.2v-5.8c0-1.7-1.3-3-3-3s-3 1.3-3 3v7.1c0 .7.1 1.4.4 2.1l3.6 9.1 2 9.7-1 6.2c-.1.5.3 1.1.8 1.1.5.1 1.1-.3 1.1-.8l.9-5.5h10.3l3.2 19.6c.1.6 0 1.2-.4 1.7s-.9.7-1.5.7c-.9 0-1.7-.6-1.9-1.5l-3.5-17.7c-.1-.5-.5-.8-1-.8s-.9.3-1 .8l-3.4 17.7c-.2.9-1 1.5-1.9 1.5-.6 0-1.2-.3-1.5-.7-.4-.5-.5-1.1-.4-1.7l1.7-10.3c.1-.5-.3-1.1-.8-1.1-.7-.2-1.2.2-1.3.8l-1.6 10.3c-.2 1 0 1.9.5 2.8h-2.3c-.6 0-1 .4-1 1s.4 1 1 1h36c.6 0 1-.4 1-1s-.4-1.1-1-1.1zm-29.2-24-1.8-9.3-3.7-9.3c-.2-.4-.3-.8-.3-1.3v-7.1c0-.6.4-1 1-1s1 .4 1 1v6.2l4.1 10.2c.2.4.5.6.9.6h8c.4 0 .8-.2.9-.6l4.1-10.2v-6.2c0-.6.4-1 1-1s1 .4 1 1v7.1c0 .5-.1.9-.3 1.4l-3.7 9.2-1.8 9.3zm2.3 24c.2-.3.3-.7.4-1.1l2.5-12.6 2.5 12.7c.1.4.2.7.4 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#df2c30",
    d: "m16 61h-14c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m26.9 11h10c.6 0 1-.4 1-1s-.4-1-1-1h-10c-.6 0-1 .4-1 1s.5 1 1 1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#df2c30",
    d: "m61 16v-5h1c.6 0 1-.4 1-1s-.4-1-1-1h-1v-5c0-.6-.4-1-1-1h-3v-1c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v7h-4c-.6 0-1 .4-1 1s.4 1 1 1h4v7c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-1h3c.6 0 1-.4 1-1zm-2-1h-2v-5.4c0-.6-.4-1-1-1s-1 .4-1 1v7.4h-2v-14h2v3.1c0 .6.4 1 1 1s1-.4 1-1v-1.1h2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#df2c30",
    d: "m16.9 9h-3.9v-7c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v1h-3c-.6 0-1 .4-1 1v5h-1c-.6 0-1 .4-1 1s.4 1 1 1h1v5c0 .6.4 1 1 1h3v1c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-7h3.9c.6 0 1-.4 1-1s-.5-1-1-1zm-5.9 8h-2v-3c0-.6-.4-1-1-1s-1 .4-1 1v1h-2v-10h2v5c0 .6.4 1 1 1s1-.4 1-1v-7h2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraining);
export default __webpack_public_path__ + "static/media/icon-training.2217d3b788a752e0327433008d4c282d.svg";
export { ForwardRef as ReactComponent };